import { Device } from '@chat/utils';
import { produce } from 'immer';
import { IndexState } from '@/typings/reducer';
import { INDEX_TYPE, IndexModifyAction } from './actionType';

const INITIAL_STATE: IndexState = {
    orientation: 'portrait',
    isLoading: false,
    guest: true,
    user_head_img: '',
    user_nick: '',
    Device: new Device(), // 设备
    base_config: {},
    dify_log_workflow_run_id: ''
};
const actionHandler: IndexModifyAction = {
    [INDEX_TYPE.SET_USER_INFO]: (state, payload) => ({
        ...state,
        ...payload
    }),
    [INDEX_TYPE.SET_LOADING_STATUS]: (state, payload) => ({
        ...state,
        isLoading: payload
    }),
    [INDEX_TYPE.SET_BASE_CONFIG]: (state, payload) => ({
        ...state,
        base_config: payload
    }),
    [INDEX_TYPE.SET_CONTACT]: (state, payload) =>
        produce(state, (draft) => {
            draft.base_config.contact = payload;
        }),
    [INDEX_TYPE.SET_FORM_TIP]: (state, payload) =>
        produce(state, (draft) => {
            draft.base_config.form_setting.tip = payload;
        }),
    [INDEX_TYPE.SET_ORIENTATION]: (state, payload) => ({
        ...state,
        orientation: payload
    }),
    [INDEX_TYPE.SET_DIFY_LOG_WORKFLOW_RUN_ID]: (state, payload) => ({
        ...state,
        dify_log_workflow_run_id: payload
    }),

    [INDEX_TYPE.SET_DEFAULT_USER_STATE]: () => INITIAL_STATE
};

export default function index(
    state = INITIAL_STATE,
    action: { type: string; payload: any }
): IndexState {
    return actionHandler[action.type] ? actionHandler[action.type](state, action.payload) : state;
}
